import { combineEpics } from 'redux-observable';
import { onUpdateClientLpToggleEditEpic } from './_epics/onUpdateClientLpToggleEdit.epic';

export const controllerClientLpEpic = combineEpics(
  onUpdateClientLpToggleEditEpic,
);
